import { render, staticRenderFns } from "./suggestion-detail.vue?vue&type=template&id=f69cbc70&"
import script from "./suggestion-detail.vue?vue&type=script&lang=js&"
export * from "./suggestion-detail.vue?vue&type=script&lang=js&"
import style0 from "./suggestion-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports